import { render, staticRenderFns } from "./Texture.vue?vue&type=template&id=34fe0d03&scoped=true&"
import script from "./Texture.vue?vue&type=script&lang=js&"
export * from "./Texture.vue?vue&type=script&lang=js&"
import style0 from "./Texture.vue?vue&type=style&index=0&id=34fe0d03&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fe0d03",
  null
  
)

export default component.exports